import { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

const get = (obj, path) => path.split(".").reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("bc-lang") || "pt");

  const changeLang = useCallback((l) => {
    localStorage.setItem("bc-lang", l);
    setLang(l);
  }, []);

  const t = useCallback(
    (key) => {
      const v = get(translations[lang], key);
      if (v !== undefined) return v;
      return get(translations.pt, key) ?? key;
    },
    [lang]
  );

  return <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);
